import { render, staticRenderFns } from "./OrganizerApp.vue?vue&type=template&id=3dd1c16c&"
import script from "./OrganizerApp.vue?vue&type=script&lang=js&"
export * from "./OrganizerApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports